
export const SET_MESSAGGIO = "SET_MESSAGGIO"

export const RESET_MESSAGGIO = "RESET_MESSAGGIO"

export const SET_SNACKBAR = "SET_SNACKBAR"

export const RESET_SNACKBAR = "RESET_SNACKBAR"